import type { LucideProps } from "lucide-react"
import type { ComponentType, SVGProps } from "react"

import { cn } from "@/lib/utils"

type LucideIconProps = {
  iconNode: ComponentType<LucideProps>
} & Omit<LucideProps, "ref">

type CustomIconProps = {
  iconNode: ComponentType<SVGProps<SVGSVGElement>>
} & Omit<SVGProps<SVGSVGElement>, "ref">

type IconProps = LucideIconProps | CustomIconProps

export function Icon({
  iconNode: IconComponent,
  className,
  ...props
}: IconProps) {
  return <IconComponent className={cn("h-4 w-4", className)} {...props} />
}
